import { apiClient } from '@/core/api/client';
import { ENDPOINTS } from '@/core/api/endpoints';
function mapUsuario(u) {
    return {
        id: u.id,
        email: u.email,
        nombreCompleto: `${u.nombre} ${u.apellido}`.trim(),
        roles: u.roles,
        sucursalPreferidaId: u.sucursalPreferidaId,
        esPromotor: u.esPromotor ?? false,
        esPromotorExterno: u.esPromotorExterno ?? false,
        promotorId: u.promotorId ?? null,
        promotorNombre: u.promotorNombre ?? null,
    };
}
export const authApi = {
    async login(datos) {
        const res = await apiClient.post(ENDPOINTS.auth.login, { email: datos.email, password: datos.password }, { headers: { 'X-Skip-Auth': '1' } });
        return {
            accessToken: res.data.access,
            refreshToken: res.data.refresh,
            usuario: mapUsuario(res.data.usuario),
        };
    },
    async logout(refreshToken) {
        await apiClient.post(ENDPOINTS.auth.logout, refreshToken ? { refresh: refreshToken } : {});
    },
    async me() {
        const res = await apiClient.get(ENDPOINTS.auth.me);
        return mapUsuario(res.data);
    },
    async forgotPassword(datos) {
        await apiClient.post(ENDPOINTS.auth.forgot, datos, {
            headers: { 'X-Skip-Auth': '1' },
        });
    },
    async resetPassword(datos) {
        await apiClient.post(ENDPOINTS.auth.reset, { token: datos.token, password: datos.password }, { headers: { 'X-Skip-Auth': '1' } });
    },
};
